import trans from "../../../../utils";


const EXPIRY_COLORS = {
  EXPIRED:  { bg: "#fff1f0", border: "#ffa39e", text: "#ff4d4f", activeBg: "#ff4d4f" },
  CRITICAL: { bg: "#fff7e6", border: "#ffd591", text: "#fa8c16", activeBg: "#fa8c16" },
  WARNING:  { bg: "#fffbe6", border: "#ffe58f", text: "#faad14", activeBg: "#faad14" },
  VALID:    { bg: "#f6ffed", border: "#b7eb8f", text: "#52c41a", activeBg: "#52c41a" },
};

const STATUS_BUCKETS = [
  { key: "EXPIRED",  countKey: "expiredCount",  qtyKey: "expiredQuantity",  labelKey: "Expired" },
  { key: "CRITICAL", countKey: "criticalCount", qtyKey: "criticalQuantity", labelKey: "Critical" },
  { key: "WARNING",  countKey: "warningCount",  qtyKey: "warningQuantity",  labelKey: "Warning" },
  { key: "VALID",    countKey: "validCount",    qtyKey: "validQuantity",    labelKey: "Valid" },
];

export default function ProductExpirationWidgets({ summary, filters, setFilters }) {
  if (!summary) return null;

  const handleBucketClick = (statusKey) => {
    if (filters?.expiryStatus === statusKey) {
      setFilters((prev) => ({ ...prev, expiryStatus: undefined }));
    } else {
      setFilters((prev) => ({ ...prev, expiryStatus: statusKey }));
    }
  };

  return (
    <div className="row mb-3">
      {STATUS_BUCKETS.map(({ key, countKey, qtyKey, labelKey }) => {
        const count = summary[countKey] ?? 0;
        const qty   = summary[qtyKey]   ?? 0;
        const isActive = filters?.expiryStatus === key;
        const colors = EXPIRY_COLORS[key];

        return (
          <div className="col-lg-3 col-md-6 mb-3" key={key}>
            <div
              onClick={() => handleBucketClick(key)}
              style={{
                cursor: "pointer",
                backgroundColor: isActive ? colors.activeBg : colors.bg,
                border: `2px solid ${isActive ? colors.activeBg : colors.border}`,
                borderRadius: 8,
                padding: "16px 20px",
                textAlign: "center",
                transition: "all 0.2s",
                userSelect: "none",
                height: "100%",
              }}
            >
              <div style={{ fontSize: 14, fontWeight: 600, color: isActive ? "#fff" : colors.text, marginBottom: 6 }}>
                {trans(labelKey)}
              </div>
              <div style={{ fontSize: 26, fontWeight: 700, color: isActive ? "#fff" : "#333", lineHeight: 1.2 }}>
                {count}
              </div>
              <div style={{ fontSize: 12, color: isActive ? "rgba(255,255,255,0.85)" : "#888", marginTop: 4 }}>
                {trans("Qty")}: {qty}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
